import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_price_book_rule_ext_RowClass} from '../../../dbschema/bl_fi_mst_price_book_rule_ext.model';
import {bl_fi_mst_price_book_rule_hdr_RowClass} from '../../../dbschema/bl_fi_mst_price_book_rule_hdr.model';
import {bl_fi_mst_price_book_rule_line_RowClass} from '../../../dbschema/bl_fi_mst_price_book_rule_line.model';

export class PriceBookRuleContainerModel extends BaseContainerModel {
  bl_fi_mst_price_book_rule_hdr: bl_fi_mst_price_book_rule_hdr_RowClass = new bl_fi_mst_price_book_rule_hdr_RowClass();
  bl_fi_mst_price_book_rule_exts: bl_fi_mst_price_book_rule_ext_RowClass[] = [];
  bl_fi_mst_price_book_rule_lines: bl_fi_mst_price_book_rule_line_RowClass[] = [];
}
